import angular from 'angular';
import template from './template.html';
import './style.scss';

export class EducationSection {}

export const EducationSectionConfiguration = {
    template,
    controller: EducationSection,
    bindings: {
        educationHistory: '<',
        canEdit: '<',
    },
    controllerAs: 'educationSectionCtrl'
};

angular.module('TALENYA-FE').component('candidateEducationSection', EducationSectionConfiguration);
